<template>
	<div class="payDetails">
		<div class="flexRow" style="justify-content: space-between;">
			<el-tabs v-model="listState" @tab-click="filterFun" style="flex:1">
				<el-tab-pane v-for="item in listStateList" :key="item.id" :label="item.value" :name="item.id+''"></el-tab-pane>
			</el-tabs>
			<el-link href="https://jusnn6k8al.feishu.cn/docs/doccnHW9y3oGSaogp3lB3JCbldc" 
			 :underline="false" target="_blank" type="primary" class="link">查看业绩统计说明></el-link>
		</div>

		<div class="filter-container">
			<div class="filter-item">
				<label class="label" style="width: 75px;display: inline-block;text-align: right;">关键字: </label>
				<el-input v-model="searchKey" :placeholder="placeholderHold" style="width: 250px;" clearable></el-input>
			</div>
			<div class="filter-item">
				<label class="label">配送方式: </label>
				<el-select v-model="SendType" placeholder="请选择" filterable clearable style="width: 160px;margin-right: 10px;">
					<el-option :value="null" label="全部"></el-option>
					<el-option v-for="(item,index) in SendTypeList" :key="index" :label="item.Name" :value="item.Id">
					</el-option>
				</el-select>
			</div>

		</div>
		<div class="filter-container">
			<div class="filter-item">
				<label class="label" v-if="listState==0">支付时间: </label>
				<label class="label" v-if="listState==1">退款时间: </label>
				<el-date-picker type="datetime" placeholder="选择日期" v-model="starTime" style="width: 250px;"
				 value-format="yyyy-MM-dd HH:mm:ss" format="yyyy-MM-dd HH:mm:ss" :clearable="false"></el-date-picker> ~
				<el-date-picker type="datetime" placeholder="选择日期"  v-model="endTime" style="width: 250px;"
				 value-format="yyyy-MM-dd HH:mm:ss" format="yyyy-MM-dd HH:mm:ss" :clearable="false"></el-date-picker>
			</div>
			<div class="filter-item">
				<el-button type="primary" style="margin-left:30px;width:90px;" @click="doorListFilter">查询</el-button>
				<el-button style="margin-left:30px;width:90px;" @click="exportFun">导出</el-button>
			</div>
		</div>
		<!-- 表格 -->
		<div class="table-container" v-if="listState==0">
			<el-table :data="groupData" v-loading="loading" ref="table">
				<el-table-column prop="OrderNo" key="OrderNo" label="订单编号" min-width="220">
					<template slot-scope="scope">
						<div style="color:red">[{{scope.row.SendTypeDisplay}}]</div>
						<div style="color:#409EFF;cursor: pointer;" @click='pushTorderdetail(scope.row)'>{{scope.row.OrderNo}}</div>
					</template>
				</el-table-column>
				<el-table-column prop="OrderMoney" key="OrderMoney" label="订单支付入账(元)">
					<template slot-scope="scope">
						<div>
							<div>{{scope.row.BusinessOrderMoney.toFixed(2)}}</div>
							<div>(含运费{{scope.row.FreightMoney}}元)</div>
						</div>
					</template>
				</el-table-column>
				<el-table-column prop="DisplayTime" key="DisplayTime" label="支付时间" width="150"></el-table-column>
				<el-table-column prop="BrandName" label="店员" key="EmployeeName" min-width="150">
					<template slot-scope="scope">
						<div>{{scope.row.EmployeeName}}</div>
						<div style="color:rgb(113, 111, 111);">{{scope.row.EmployeePhone}}</div>
					</template>
				</el-table-column>
				<el-table-column prop="ProductName" key="ProductName" label="商品" min-width="300">
					<template slot-scope="scope">
						<div class="twoSpless">
							{{scope.row.ProductName}}
						</div>
					</template>
				</el-table-column>
				<el-table-column prop="SpecValue" key="SpecValue" label="规格">
					<template slot-scope="scope">
						<div>
							<div class="oneSpless">
								{{scope.row.SpecDisplay}}
							</div>
							<div>{{scope.row.BarCode}}</div>
						</div>
					</template>
				</el-table-column>
				<el-table-column prop="ProductCount" key="ProductCount" label="购买数量"></el-table-column>
				<el-table-column prop="BusinessMoney" key="BusinessMoney" label="商品支付入账(元)">
					<template slot-scope="scope">
						{{scope.row.BusinessMoney.toFixed(2)}}
					</template>
				</el-table-column>
			</el-table>
			<div style="text-align: right;">
				<el-pagination v-if="Total" style="margin:20px 0" @size-change="handleSizeChange" @current-change="handleCurrentChange"
				 :current-page="currentPage" :page-sizes="[10, 20, 30, 40, 50]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper"
				 :total="Total">
				</el-pagination>
			</div>
		</div>

		<div class="table-container" v-else>
			<el-table :data="groupData" v-loading="loading" ref="table">
				<el-table-column prop="" label="退款单号" min-width="220" key="SupportNo2">
					<template slot-scope="scope">
						<div style="color:red">[{{scope.row.SendTypeDisplay}}]</div>
						<div style="color:#409EFF;cursor: pointer;" @click='pushTorefundDetail(scope.row)'>{{scope.row.SupportNo}}</div>
					</template>
				</el-table-column>
				<el-table-column prop="" label="退款金额" key="RealRefundMoney2">
					<template slot-scope="scope">
						<div>
							<div>{{scope.row.RealRefundMoney.toFixed(2)}}</div>
							<div>(含运费{{scope.row.RefundFreightMoney}}元)</div>
						</div>
					</template>
				</el-table-column>
				<el-table-column prop="CompleteTime" key="CompleteTime2" label="退款时间" width="150"></el-table-column>
				<el-table-column prop="ProductCount" label="退款数量" key="ProductCount"></el-table-column>
				<el-table-column prop="" label="店员" key="EmployeeName2" min-width="150">
					<template slot-scope="scope">
						<div>{{scope.row.EmployeeName}}</div>
						<div style="color:rgb(113, 111, 111);">{{scope.row.EmployeePhone}}</div>
					</template>
				</el-table-column>
				<el-table-column prop="" label="商品" key="ProductName2" min-width="300">
					<template slot-scope="scope">
						<div class="twoSpless">
							{{scope.row.ProductName}}
						</div>
					</template>
				</el-table-column>
				<el-table-column prop="" label="规格" key="SpecDisplay2">
					<template slot-scope="scope">
						<div>
							<div class="oneSpless">
								{{scope.row.SpecDisplay}}
							</div>
							<div>{{scope.row.BarCode}}</div>
						</div>
					</template>
				</el-table-column>
			</el-table>
			<div style="text-align: right;">
				<el-pagination v-if="Total" style="margin:20px 0" @size-change="handleSizeChange" @current-change="handleCurrentChange"
				 :current-page="currentPage" :page-sizes="[10, 20, 30, 40, 50]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper"
				 :total="Total">
				</el-pagination>
			</div>
		</div>


	</div>
</template>

<script>
	import {
		shopPerformanceorder,
		shopPerformanceRefund,
		shopPerformanceorderv2,
		shopPerformanceRefundv2
	} from '@/api/goods'
	import config from '@/config/index'
	export default {
		data() {
			return {
				placeholderHold:'订单编号',
				loading: false,
				listStateList: [{
						id: 0,
						value: '支付订单'
					},
					{
						id: 1,
						value: '退款单'
					}
				],
				listState: '0',
				searchKey: "",
				SendType: '',
				SendTypeList: [{
						Id: 0,
						Name: '快递发货'
					},
					{
						Id: 1,
						Name: '到店自提'
					},
					{
						Id: 2,
						Name: '同城配送'
					}
				],
				pickerOptions: {
					disabledDate(time) {
						let curDate = (new Date()).getTime();
						let three = 30 * 24 * 3600 * 1000;
						let threeMonths = curDate - three;
						return time.getTime() > Date.now() || time.getTime() < threeMonths;
					}
				},
				starTime: '',
				endTime: '',
				currentPage: 1,
				pageSize: 20,
				Total: 0,
				groupData: [],
				exportUrl: config.EXPORT_URL,
				goUrls: config.GO_URL,
			}
		},
		beforeMount() {
			this.getNowDay()
			this.getList()
		},
		methods: {
			testtime(){
				let starTime = this.starTime
				let endTime = this.endTime
				if(!starTime||!endTime){
					this.$message.error('最多可查询92天内的订单，请重新选择时间!')
					return false
				}else{
					let time =  (new Date(endTime).getTime()-new Date(starTime).getTime())/1000/60/60/24 > 92
					if(time){
						this.$message.error('最多可查询92天内的订单，请重新选择时间!')
						return false
					}
					return true
				}
			},
			//跳转到退款单详情
			pushTorefundDetail(record){
				let OrderNoId = record.SupportNo ? record.SupportNo : 0
				let headsUrls=process.env.NODE_ENV == 'production'?'index.html#':''
				let url=this.goUrls+headsUrls+'/order/refundAfterSale/refundDetails?id='+OrderNoId				
				window.open(url)	
			},
			//跳转到订单详情
			pushTorderdetail(record){
				let OrderNoId = record.OrderNo ? record.OrderNo : 0
				let headsUrls = process.env.NODE_ENV == 'production' ? 'index.html#' : ''
				let url = this.goUrls + headsUrls + '/order/orderDetailpage?Id=' + OrderNoId
				
				window.open(url)
			},
			// 获取主列表时间
			getNowDay() {
				this.starTime = this.$route.query.starTime;
				this.endTime = this.$route.query.endTime;
			},
			async getList() {
				if(!this.testtime()) return
				try {
					// this.starTime = '2022-5-2'
					this.loading = true
					let data = {
						Keywords: this.searchKey,
						SendType: this.SendType,
						StartTime: this.starTime,
						EndTime: this.endTime,
						ShopId: this.$route.query.Id,
						PerformanceType: 0,
						Skip: (this.currentPage - 1) * this.pageSize, // 略过数据
						Take: this.pageSize, // 取的数据
					}
					if (this.listState == 0) {
						let result = await shopPerformanceorderv2(data)
						this.Total = result.Result.Total;
						this.groupData = result.Result.Results || [];
					} else {
						let result1 = await shopPerformanceRefundv2(data)
						this.Total = result1.Result.Total;
						this.groupData = result1.Result.Results || [];
					}

					this.$nextTick(()=>{
						this.$refs.table.doLayout()
					})


				} catch (e) {
					//TODO handle the exception
					console.log(e)
				} finally {
					this.loading = false
				}

			},
			filterFun() {
				this.searchKey = ''
				this.SendType = ''
				this.currentPage = 1
				this.pageSize = 20
				//结算
				if(this.listState == 0){
					this.placeholderHold="订单编号"
				}else{
					this.placeholderHold="退款单号"
				}
				this.getNowDay()
				this.getList()
			},
			// 查询
			doorListFilter() {
				if (!this.starTime || (!this.endTime) || (new Date(this.endTime).getTime()-new Date(this.starTime).getTime())/1000/60/60/24 > 92) {
					this.$message({
						showClose: true,
						type: 'error',
						message: '最多可查询92天内的订单，请重新选择时间!'
					});
					return
				}

				this.currentPage = 1
				this.getList()
			},
			exportFun() {
				if(!this.testtime()) return
				let exportStyle = this.listState == 0 ? '/pc/shop-performance/order-index/v2?' :
					'/pc/shop-performance/refund-index/v2?'

				let url = this.exportUrl + exportStyle +
					'&Keywords=' + (this.searchKey ? encodeURIComponent(this.searchKey) : '') +
					'&SendType=' + this.SendType +
					'&StartTime=' + (this.starTime ? this.starTime : '') +
					'&EndTime=' + (this.endTime ? this.endTime : '') +
					'&PerformanceType=' + 0 +
					'&ShopId=' + this.$route.query.Id
				window.open(url);

			},
			// 切换显示条数
			handleSizeChange(val) {
				// console.log(`每页 ${val} 条`);
				this.pageSize = val;
				this.getList();
			},

			// 翻页
			handleCurrentChange(val) {
				console.log(`当前页: ${val}`);
				this.currentPage = val;
				this.getList();
			},

		}
	}
</script>

<style lang="less" scoped>
	.payDetails {
		background: #fff;
		padding: 15px;

		.twoSpless {
			overflow: hidden;
			text-overflow: ellipsis;
			display: -webkit-box;
			-webkit-box-orient: vertical;
			-webkit-line-clamp: 2;
		}

		.oneSpless {
			overflow: hidden;
			white-space: nowrap;
			text-overflow: ellipsis;
		}
	}
	.flexRow{
		display: flex;
		align-items: center;
		// justify-content: space-between;
		position: relative;
		.link{
			position: absolute;
			right: 0px;
			top: 15px;
		}
	}
</style>
